import fetch from "~/utils/fetch";

import { getMessage } from "~/order/selectors";
import { ProductStock } from "~/product/types";
import { ServerTenant } from "~/tenant/types";
import { ProductPriceCheckItem } from "./types";

export default {
  checkout: ({
    phone,
    items,
    orderId,
    t,
    mapPrices,
    couponInfo,
    fields,
    state,
    preference = null,
    country = undefined as string | undefined,
    tier = undefined as ServerTenant["tier"] | undefined,
    hideDecimals = false,
  }) =>
    `https://wa.me/${phone}?text=${encodeURIComponent(
      getMessage(
        items,
        orderId,
        t,
        mapPrices,
        couponInfo,
        fields,
        state,
        preference ?? undefined,
        country,
        tier,
        hideDecimals
      )
    )}`,
  // El tenantId viaja en todos estos endpoints porque los ids de producto no
  // alcanzan para ubicar la tienda: hay catálogos clonados que comparten ids y
  // el server terminaba validando contra el documento de otro comercio.
  updateStock: (products: ProductStock[], tenantId: ServerTenant["id"]) => {
    return fetch(
      "PATCH",
      "/api/productStock",
      { products, tenantId },
      {
        Authorization: window.localStorage.getItem("token"),
      }
    );
  },
  checkStock: (products: ProductStock[], tenantId: ServerTenant["id"]) => {
    return fetch(
      "POST",
      "/api/productStock",
      { products, tenantId },
      {
        Authorization: window.localStorage.getItem("token"),
      }
    );
  },
  checkPrices: (
    products: ProductPriceCheckItem[],
    tenantId: ServerTenant["id"]
  ) => {
    return fetch(
      "POST",
      "/api/checkPrices",
      { products, tenantId },
      {
        Authorization: window.localStorage.getItem("token"),
      }
    );
  },
};
